import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';

@Component({
  components: { DsModal },
})
export default class ConnectYoutubeComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @PropSync('channelConnect', { type: Object }) syncedChannelConnect!: any;

  showModal = this.open;
  formData = {
    dataSourceType: 'YOUTUBE',
    YOUTUBE_TRENDING: '',
    YOUTUBE_MY_SUBSCRIPTION: '',
    YOUTUBE_MY_CHANNEL: '',
    YOUTUBE_URL: '',
    YOUTUBE_KEYWORD: '',
  } as any;

  handleAddDataSourceItem() {
    const data: any = {
      channelId: String(Math.random()),
      channelName: 'YOUTUBE',
      channelDescription: this.formData.channelName || '',
      channelImageUri: 'https://doctornow.co.kr/favicon.png',
      channelType: 'YOUTUBE',
      allowAccess: 'true',
      accounts: [
        {
          accountId: new Date()
            .toISOString()
            .replace(/[-T:.Z]/g, '')
            .slice(0, 14), // yyyyMMddHHmmss
          accountName: '-',
          dataSource: this.formData,
          password: '',
          isScrap: true,
        },
      ],
    };
    this.$emit('addDataSourceYoutube', data);
  }

  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
  }
}
